import { inject, Injectable, NgZone } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import posthog from 'posthog-js';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PosthogService {
  private authService = inject(AuthService);
  private ngZone = inject(NgZone);
  private initialized = false;

  async initializeForUser(): Promise<void> {
    if (this.initialized) return;

    this.authService.isAuthenticated().then(async isAuthenticated => {
      if (!isAuthenticated) return;
      const user = await this.authService.currentUserAttributes();
      if (!user) return;

      this.ngZone.runOutsideAngular(() => {
        posthog.init(environment.POSTHOG_KEY, {
          api_host: environment.POSTHOG_API_HOST,
          ui_host: environment.POSTHOG_UI_HOST,
          person_profiles: 'identified_only',
          defaults: '2026-01-30',
          session_recording: {
            recordCrossOriginIframes: false, 
          }
        });

        posthog.identify(user.sub, {
          email: user.email,
          firstname: user.name,
          lastname: user.family_name
        });
      });

      this.initialized = true;
    });
  }

  capture(event: string, properties?: Record<string, any>): void {
    if (this.initialized) {
      this.ngZone.runOutsideAngular(() => {
        posthog.capture(event, properties);
      });
    }
  }

  captureException(error: unknown): void {
    if (this.initialized) {
      this.ngZone.runOutsideAngular(() => {
        posthog.captureException(error);
      });
    }
  }

}
